function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './FiltersSelected.css';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { addQueryStringMultiple } from '../../../Listing';
import { useSitecoreContext } from '../../../../utils/SitecoreContextReactContext';
import { ReactComponent as IconClose } from '../../../../resources/icons/close-tag.svg';
const commonStyles = "czqby32";
const ltrStyles = "l1ggbil2";
const rtlStyles = "r1am63l0";
const FiltersSelected = _ref => {
  let {
    filterState,
    setFilter,
    clearText,
    setListingFilter,
    facets,
    resetAndSubmitFilters,
    analyticsClick
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const history = useHistory();
  const getFiltersToDisplay = () => {
    const filters = _objectSpread({}, filterState);
    for (const key in filters) {
      const item = filters[key];
      const facetType = item.facetName;
      const availableValues = facets[facetType];
      if (availableValues) {
        item.value = item.value.filter(val => val in availableValues);
      }
    }
    return filters;
  };
  const filtersToDisplay = getFiltersToDisplay();
  const filtersToDisplayArray = Object.keys(filtersToDisplay);
  let selectedItemsLength = 0;
  filtersToDisplayArray.forEach(item => {
    selectedItemsLength += filterState[item].value.length;
  });
  if (!selectedItemsLength) return null;
  return /*#__PURE__*/React.createElement("ul", {
    className: `filters__selected ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, filtersToDisplayArray.map((filterFieldTitle, index) => filtersToDisplay[filterFieldTitle].value.map(tagName => /*#__PURE__*/React.createElement("li", {
    className: "filters__selected-item",
    key: tagName
  }, tagName, /*#__PURE__*/React.createElement("button", {
    className: "filters__selected-remove-btn",
    onClick: () => {
      const newValues = filtersToDisplay[filterFieldTitle].value.filter(item => item !== tagName);
      const selected = {
        [tagName]: false
      };
      setFilter({
        [filterFieldTitle]: _objectSpread(_objectSpread({}, filtersToDisplay[filterFieldTitle]), {}, {
          value: newValues
        })
      });
      addQueryStringMultiple(filtersToDisplay[filterFieldTitle].facetName, selected, history);
      setListingFilter();
      analyticsClick(tagName);
    }
  }, /*#__PURE__*/React.createElement(IconClose, null))))), /*#__PURE__*/React.createElement("li", {
    className: "filters__selected-item-clear"
  }, /*#__PURE__*/React.createElement("button", {
    className: "filters__selected-clear-btn",
    onClick: resetAndSubmitFilters
  }, clearText)));
};
export default FiltersSelected;